import { Injectable, signal } from '@angular/core';

@Injectable({providedIn: 'root'})
export class ChatBotService {

    readonly chatBotDrawerState = signal(false);

    toggleDrawer() {
        this.chatBotDrawerState.update(curr => !curr);
    }

    openDrawer() {
        this.chatBotDrawerState.set(true);
    }

    closeDrawer() {
        this.chatBotDrawerState.set(false);
    }

}
